import { IoMdClose } from "react-icons/io";
import { motion } from "framer-motion";
import { FaRocket } from "react-icons/fa";

export function ComingSoonModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-[999] px-4">
      {/* Animated Modal Container */}
      <motion.div
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.85 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="bg-white p-8 rounded-3xl shadow-2xl relative w-full max-w-lg md:max-w-2xl text-center overflow-hidden"
      >
        {/* Soft Gradient Glow Effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-600 opacity-10 blur-2xl"></div>

        {/* Rocket Icon with Launch Animation */}
        <motion.div
          animate={{ y: [-5, 5, -5] }}
          transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
          className="flex justify-center"
        >
          <FaRocket className="text-blue-600 text-6xl md:text-7xl" />
        </motion.div>

        {/* Title with Moving Gradient Effect */}
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-500 mt-4"
          animate={{ scale: [1, 1.05, 1] }}
          transition={{ repeat: Infinity, duration: 2 }}
        >
          Coming Soon
        </motion.h2>

        {/* Description Text */}
        <p className="text-gray-600 mt-3 text-lg">
          We're working on something <span className="text-blue-500 font-semibold">amazing</span>. Stay tuned!
        </p>

       
        {/* Buttons */}
        <button
          className="mt-6 w-full px-6 py-3 bg-blue-600 text-white rounded-lg shadow-lg text-lg font-semibold hover:bg-blue-700 transition"
          onClick={onClose}
        >
          Close
        </button>

        {/* Close Icon Button */}
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition"
          onClick={onClose}
        >
          <IoMdClose size={26} />
        </button>
      </motion.div>
    </div>
  );
}
